import { Injectable } from '@angular/core';
import { clone } from 'lodash';
import { Observable, Subject } from 'rxjs';
import { CompanyConfig } from 'src/config';
import { Company, CompanyPaymentType, Country, Currency } from 'src/app/models/verylys';
import { AbstractService, PaginationResult, PopulateRequest } from '../abstract/abstract.service';
import { VlApiService } from '../vl-api/vl-api.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends AbstractService<Company> {
  route: string = "/companies/";
  resourceReferenceLabel = "Company";

  protected crudMethods = {
    create: false,
    update: false,
    delete: false,
    get: true,
    getAll: false,
    currency: false
  }

  protected cacheMethods: { get: boolean, getAll: boolean } = {
    get: true,
    getAll: false
  }

  /*public getAvailableCountries(): Observable<Country[]> {
    return this.vlapi.get<Currency[]>(`${this.route}${CompanyConfig.id}/available-countries`, { cache: true });
  }

  public getAvailableCurrencies(): Observable<Currency[]> {
    return this.vlapi.get<Currency[]>(`${this.route}${CompanyConfig.id}/available-currencies`, { cache: true });
  }

  public getAvailablePaymentMethods(): Observable<CompanyPaymentType[]> {
    return this.vlapi.get<CompanyPaymentType[]>(`${this.route}${CompanyConfig.id}/available-payment-types`, {
      populateRequest: {
        populateFileMedias: true
      },
      cache: true
    });
  }*/

  public validate(value: Company, ...args: any): void {
    throw new Error('Method not implemented.');
  }
}
